import React from 'react';
import { AppState, Auth0Provider } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

export const redirectUri =
  !process.env.NODE_ENV || process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000'
    : 'https://events.aiescape.io';

const domain = 'auth.aiescape.io';
const clientId = 'bHoORwzLVQQQwAhqAp35CpooC3OiaBFn';
const audience = 'https://events-api.aiescape.io';

export type Auth0ProviderWithHistoryProps = {
  children: React.ReactNode;
};

export const authParams = {
  audience,
  redirect_uri: redirectUri,
  scope: 'openid profile email offline_access',
  organization: 'org_pn5YrEElYRSQa5Dz',
};

function Auth0ProviderWithHistory(props: Auth0ProviderWithHistoryProps) {
  const { children } = props;
  const navigate = useNavigate();

  const onRedirectCallback = (appState?: AppState) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider
      authorizationParams={authParams}
      cacheLocation="localstorage"
      clientId={clientId}
      domain={domain}
      useRefreshTokens
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
}

export default Auth0ProviderWithHistory;
